import { Button, Text } from '@mantine/core';
import type { FC } from 'react';

type Props = {
  buttonText: string;
};

const QuestionButton: FC<Props> = ({ buttonText }) => {
  return (
    <Button
      radius={8}
      w={36}
      h={36}
      fz={12}
      p={8}
      maw={36}
      variant={'filled'}
      color='red'
      style={{
        boxShadow: '0px 5px 5px rgba(0, 0, 0, 0.25)',
      }}>
      <Text>{buttonText}</Text>
    </Button>
  );
};

export default QuestionButton;
